import { useTranslations } from 'next-intl';
import React from 'react';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
// import { reFormatRelativeTime, setPSTZone } from '../../utils/dates';
import { formatJsDateToRelativeDate } from '@wwe-portal/utils/date/datefns';

function LastRefresh({ lastActivityDate }) {
  const t = useTranslations();
  // const lastActivity = setPSTZone(lastActivityDate).startOf('day');
  const lastActivity = formatJsDateToRelativeDate(lastActivityDate ?? '');

  return (
    <div className="text-text700 my-5 flex items-center justify-center gap-2 md:my-0 md:justify-end">
      <IcoMoonIcon iconName="timer" className="text-text700 mr-[5px] size-4" />
      <p className="-ml-[5px] mb-[5px] text-xs">
        {`${t('last_updated')} :`}
        <span className="text-text600 mb-0 ml-[5px] text-xs">
          {/* {reFormatRelativeTime(lastActivity)} */}
          {lastActivity}
        </span>
      </p>
    </div>
  );
}

export default LastRefresh;
